import styles from './ConsentActions.module.css';

interface ConsentActionsProps {
  onAccept: () => void;
  onReject: () => void;
}

export default function ConsentActions({
  onAccept,
  onReject,
}: ConsentActionsProps): JSX.Element {
  return (
    <div className={styles.actions}>
      <button type="button" onClick={onAccept}>
        Aceitar todos
      </button>
      <button type="button" onClick={onReject}>
        Recusar todos
      </button>
    </div>
  );
}
